export const cnpjMask = (e) => {
    const { value } = e.target
    e.target.value = value
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1/$2")
        .replace(/(\d{4})(\d)/, "$1-$2")
        .replace(/(-\d{2})\d+?$/, '$1')
}